import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vendorFinancialStatus: { loading: false, data: null, error: null },
  vendorFinancialAction: { loading: false, data: null, error: null },
};

const vendorFinancialSlice = createSlice({
  name: "afmsVendorFinancial",
  initialState,
  reducers: {
    // Status fetch
    vendorFinancialStatusStart: (state) => {
      state.vendorFinancialStatus.loading = true;
      state.vendorFinancialStatus.error = null;
    },
    vendorFinancialStatusSuccess: (state, action) => {
      state.vendorFinancialStatus.loading = false;
      state.vendorFinancialStatus.data = action.payload;
      state.vendorFinancialStatus.error = null;
    },
    vendorFinancialStatusFailure: (state, action) => {
      state.vendorFinancialStatus.loading = false;
      state.vendorFinancialStatus.error = action.payload;
    },
    vendorFinancialStatusReset: (state) => {
      state.vendorFinancialStatus = initialState.vendorFinancialStatus;
    },

    // Submit action
    vendorFinancialActionStart: (state) => {
      state.vendorFinancialAction.loading = true;
      state.vendorFinancialAction.error = null;
      state.vendorFinancialAction.data = null;
    },
    vendorFinancialActionSuccess: (state, action) => {
      state.vendorFinancialAction.loading = false;
      state.vendorFinancialAction.data = action.payload;
      state.vendorFinancialAction.error = null;
    },
    vendorFinancialActionFailure: (state, action) => {
      state.vendorFinancialAction.loading = false;
      state.vendorFinancialAction.error = action.payload;
    },
    vendorFinancialActionReset: (state) => {
      state.vendorFinancialAction = initialState.vendorFinancialAction;
    },
  },
});

export const {
  vendorFinancialStatusStart,
  vendorFinancialStatusSuccess,
  vendorFinancialStatusFailure,
  vendorFinancialStatusReset,
  vendorFinancialActionStart,
  vendorFinancialActionSuccess,
  vendorFinancialActionFailure,
  vendorFinancialActionReset,
} = vendorFinancialSlice.actions;

export default vendorFinancialSlice.reducer;
